import { render, staticRenderFns } from "./comment-tab.vue?vue&type=template&id=599cc16a&scoped=true"
import script from "./comment-tab.vue?vue&type=script&lang=js"
export * from "./comment-tab.vue?vue&type=script&lang=js"
import style0 from "./comment-tab.vue?vue&type=style&index=0&id=599cc16a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599cc16a",
  null
  
)

export default component.exports